import {
  Interaction
} from "./chunk-3DDIR7LC.mjs";
import {
  Completion
} from "./chunk-LNWWNP75.mjs";
import {
  sendEventsViaBeacon
} from "./chunk-56HYCTGH.mjs";

// src/listeners/media-listeners/setup-media-listeners.ts
function setupMediaListeners(element, metadata) {
  const session = {
    durationMillis: 0,
    lastEnd: 0,
    lastStart: 0,
    /**
     * If media metadata hasn't loaded, it's possible for duration to be NaN, so we default to `0`.
     * The `loadedmetadata` listener will also check for duration and set it here, in case it's `NaN` because the metadata is not available when these listeners are initialized.
     * The check needs to be made outside of the percent complete calculation, otherwise it returns `null`.
     */
    mediaDuration: typeof element.duration === "number" && !Number.isNaN(element.duration) ? element.duration : 0
  };
  const completionContext = element.nodeName.toLowerCase();
  const contentType = metadata?.contentType ?? completionContext;
  function handlePlay(event) {
    session.lastStart = event.timeStamp;
    Interaction.fire({
      ...metadata,
      contentType,
      elementId: "play_state",
      screenId: null,
      success: true
    });
  }
  function handlePause(event) {
    session.lastEnd = event.timeStamp;
    session.durationMillis += event.timeStamp - session.lastStart;
    Interaction.fire({
      ...metadata,
      contentType,
      elementId: "pause_state",
      screenId: null,
      success: true
    });
  }
  function fireCompletion(options) {
    let totalTimePlayed = 0;
    for (let i = 0; i < element.played.length; i += 1) {
      const start = element.played.start(i);
      const end = element.played.end(i);
      const duration = end - start;
      totalTimePlayed += duration;
    }
    Completion.fire(
      {
        ...metadata,
        completionContext,
        contentType,
        durationMillis: Math.round(session.durationMillis),
        percentComplete: session.mediaDuration > 0 ? Number((totalTimePlayed / session.mediaDuration).toFixed(4)) : 0,
        screenId: null,
        success: totalTimePlayed > 0 ? true : false
      },
      options
    );
  }
  function handleError() {
    Completion.fire({
      ...metadata,
      completionContext,
      contentType,
      screenId: null,
      success: false
    });
  }
  function handleSetMediaDuration() {
    if (typeof element.duration === "number" && !Number.isNaN(element.duration)) {
      session.mediaDuration = element.duration;
    }
  }
  function handleEnded() {
    if (window.yvaDatastore?.config.debug) {
      console.log("firing ended for", completionContext, "|", contentType);
    }
    fireCompletion();
  }
  function handleDocumentUnload() {
    if (window.yvaDatastore?.config.debug) {
      console.log("firing pagehide/beforeunload for", completionContext, "|", contentType);
    }
    fireCompletion({ callback: sendEventsViaBeacon, fireImmediately: true });
  }
  element.addEventListener("play", handlePlay);
  element.addEventListener("pause", handlePause);
  element.addEventListener("ended", handleEnded);
  element.addEventListener("error", handleError);
  element.addEventListener("loadedmetadata", handleSetMediaDuration);
  window.addEventListener("beforeunload", handleDocumentUnload);
  function cleanup() {
    if (window.yvaDatastore?.config.debug) {
      console.log("cleaning up listeners for", completionContext, "|", contentType);
    }
    element.removeEventListener("play", handlePlay);
    element.removeEventListener("pause", handlePause);
    element.removeEventListener("ended", handleEnded);
    element.removeEventListener("error", handleError);
    element.removeEventListener("loadedmetadata", handleSetMediaDuration);
    window.removeEventListener("beforeunload", handleDocumentUnload);
  }
  return {
    cleanup,
    handleDocumentUnload,
    handleEnded,
    handleError,
    handlePause,
    handlePlay
  };
}

export {
  setupMediaListeners
};
